import { FronteggContext } from '@frontegg/rest-api';
import { axios, axiosAmbient } from 'src/lib/axios';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  humanScribeLoadingSlice,
  humanScribeStatusSlice,
  possibleStatusSlice,
} from '../slices';

export const getHumanScribeStatusAction = () => {
  return async (dispatch) => {
    try {
      dispatch(humanScribeLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axios.get('/v2/human_scribe', {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(humanScribeStatusSlice(response));
      }
    } catch (error) {
      showToastError(error);
    } finally {
      dispatch(humanScribeLoadingSlice(false));
    }
  };
};

export const addHumanScribeStatusAction = (payload, setIsOpen) => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axios.post('/v2/human_scribe', payload, {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        showToastSuccess('Human scribe status added successfully');
        dispatch(humanScribeStatusSlice(response));
        setIsOpen(false);
      }
    } catch (error) {
      showToastError(error);
    }
  };
};

export const getPossibleStatusAction = () => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axiosAmbient.get('/encounter_status', {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(possibleStatusSlice(response));
      }
    } catch (error) {
      console.log(error);
    }
  };
};
